import React from "react";
import { Link } from "react-router-dom";
import AppLogo from "Assets/svg/logo/logo.svg";
import AppLogoText from "Assets/svg/logo/logo-text.svg";
import * as Icons from 'react-bootstrap-icons';

const rules = [
  {
    title: 'سیاست نامه حریم خصوصی',
    body: [
      {
        text: '«وب وین» به حریم خصوصی کاربران خود احترام می‌گذارد و متعهد به حفاظت از اطلاعات شخصی است که شما در اختیار آن می‌گذارید. از آنجا که جمع‌آوری و پردازش اطلاعات شخصی بخش غیرقابل اجتنابی در ارائه خدمات ما به شما است، لذا به منظور آگاهی کامل از سیاست و عملکرد وب‌وین در این زمینه، مطالعه این سند تحت عنوان «سیاست نامه حریم خصوصی» و هر گونه پیام دیگری که در خصوص جمع‌آوری و پردازش اطلاعات توسط وب‌وین به حساب کاربری شما ارسال می‌شود، ضروری است.',
        type: 'text',
        sub: null
      },{
        text: 'این سند مشتمل بر موارد ذیل در خصوص اطلاعات شخصی است که مطالعه آن را برای درک بهتر اصطلاحات تخصصی پیشنهاد می‌کنیم.',
        type: 'text',
        sub: null
      },
    ]
  },{
    title: 'درباره وب‌وین',
    body: [
      {
        text: 'وب وین اولین وب سایت آنلاین طراحی، ساخت و فروش انواع در و پنجره در بستر اینترنت و کاملا آنلاین و محصول جدید شرکت دانش بنیان فناوری داده پویشگر با  بیش از 2 دهه فعالیت مستمر در زمینه تولید نرم افزارهای تخصصی صنعت در و پنجره است.',
        type: 'text',
        sub: null
      },
    ]
  },{
    title: 'تغییرات این سند',
    body: [
      {
        text: 'این سند ممکن است دستخوش تغییرات و تجدیدنظر شود و در صورتی که اطلاع‌رسانی تغییرات به موجب قانون الزامی باشد، این تغییرات از طریق سایت و اینستاگرام شرکت فناوری داده پویشگر به کاربران اطلاع داده خواهد شد. این سند، آخرین بار در تاریخ 10 آذر 1403 مورد بازبینی و به‌روزرسانی قرار گرفت.',
        type: 'text',
        sub: null
      },
    ]
  },{
    title: 'سایت و سرویس‌های اشخاص ثالث',
    body: [
      {
        text: 'استفاده از خدمات وب‌وین ممکن است دربردارنده لینک‌های متعلق به اشخاص ثالث نیز باشد. به نحوی که کلیک کردن روی آن‌ها می‌تواند منجر به جمع‌آوری اطلاعات شخصی شما شود. توصیه وب وین این است که علاوه بر این سند و تغییرات آن، سیاست‌های حریم خصوصی (Privacy Policy) لینک‌های متعلق به اشخاص ثالث را نیز به دقت مطالعه کنید. وب‌وین هیچ مسئولیتی در قبال اطلاعاتی که با اشخاص ثالث (اعم از سایر کاربران وب وین یا خارج از این خدمات) به اشتراک می‌گذارید نخواهد داشت.',
        type: 'text',
        sub: null
      },
    ]
  },{
    title: 'کدام اطلاعات توسط وب‌وین جمع آوری می شوند',
    body: [
      {
        text: 'اطلاعاتی که برای ایجاد حساب کاربری در وب‌وین ضروری است شامل شماره تلفن همراه و رمز عبور (به صورت رمز‌گذاری‌شده) یا سایر اطلاعاتی که شما در اختیار وب‌وین قرار می‌دهید',
        type: 'bullet',
        sub: null
      },{
        text: 'ما ممکن است از کوکی‌ها (cookies) در جمع‌آوری اطلاعات استفاده کنیم. کوکی فایلی است که به درخواست یک سایت، توسط مرورگر ایجاد می‌شود و به سایت امکان ذخیره بازدید‌های شما و مناسب‌سازی آنها را فراهم می‌نماید. به عنوان مثال ما با استفاده از کوکی می‌توانیم محتوایی را به شما پیشنهاد بدهیم که متناسب با علاقه‌ها و ترجیحات شما باشد. بسیاری از مرورگرها امکان غیرفعال کردن کوکی را فراهم کرده‌اند، به این منظور می‌توانید راهنمای مرورگرها را مطالعه کنید. (برای مثال، Internet Explorer، Google Chrome، Mozilla Firefox و Apple Safari)',
        type: 'bullet',
        sub: null
      },{
        text: 'صدا و مکاتبات شما در تماس با تیم پشتیبانی',
        type: 'bullet',
        sub: null
      },
    ]
  },{
    title: 'وب‌وین از اطلاعات چه استفاده ای می کند',
    body: [
      {
        text: 'موارد عمده استفاده از اطلاعات عبارتند از:',
        type: 'text',
        sub: null
      },{
        text: 'استفاده از اطلاعات به منظور اجرای قرارداد فعلی یا آتی بین وب‌وین و کاربر یا در مواردی که برای استیفای حقوق قانونی وب‌وین ضروری باشد. به عبارت دیگر، از آنجا که وب‌وین برای ارائه بهترین محصولات و خدمات، با بیشترین امنیت برای کاربر و همچنین بهبود خدمات نیاز به استفاده از برخی اطلاعات دارد، بنابراین وب‌وین با استفاده از اطلاعات کاربران ممکن است اقدامات ذیل را انجام دهد:',
        type: 'bullet',
        sub: [
          {
            text: 'ارزیابی عملکرد سرویس وب‌وین و رفع اشکالات آن‌ها در نسخه‌های آتی',
            type: 'bulletInner',
            sub: null
          },{
            text: 'افزایش امنیت و صحت عملکرد سرویس',
            type: 'bulletInner',
            sub: null
          },{
            text: 'بهبود تجربۀ کاربری از طریق انطباق وب‌وین با نیازها و شرایط کاربر',
            type: 'bulletInner',
            sub: null
          },{
            text: 'تحلیل رفتار کاربران در استفاده از سرویس ',
            type: 'bulletInner',
            sub: null
          },{
            text: 'اطلاع‌رسانی رخدادهای مهم مانند به‌روزرسانی‌های خدمات و محصولات، تغییرات مهم در شرایط استفاده از وب‌وین یا سیاست‌نامه حریم خصوصی',
            type: 'bulletInner',
            sub: null
          },{
            text: 'آموزش تیم پشتیبانی برای پاسخگویی به کاربران و نظارت بر عملکرد آن‌ها',
            type: 'bulletInner',
            sub: null
          },{
            text: 'استفاده از اطلاعات برای دفاع و پاسخگویی در برابر دعاوی مطروحه علیه وب‌وین یا طرح دعوا توسط وب‌وین و هرگونه اقدام قضایی یا اداری مرتبط به منظور دفاع از حقوق و اموال کاربران و وب‌وین',
            type: 'bulletInner',
            sub: null
          },{
            text: 'انجام مکاتبات و تماس با کاربران توسط تیم پشتیبانی',
            type: 'bulletInner',
            sub: null
          },{
            text: 'توسعه و ارائه خدمات بهتر و بیشتر توسط وب‌وین یا مجموعه شرکت‌های همکار و وابسته به شرکت فناوری داده پویشگر',
            type: 'bulletInner',
            sub: null
          },
        ]
      },{
        text: 'وب‌وین اطلاعات کاربران را برای ارائه‌ی گزارش‌های آماری از صنعت و کاربران، بدون اینکه به طور مستقیم به یک شخص حقیقی مشخص و معین مرتبط باشد، استفاده می‌کند.',
        type: 'bullet',
        sub: null
      },
    ]
  },{
    title: 'اطلاعات در اختیار چه کسانی قرار می گیرد',
    body: [
      {
        text: 'وب‌وین ممکن است در راستای مطابقت عملکردش با قوانین و مقررات کشور اطلاعات موضوع این سند را در جریان رسیدگی قضایی و/یا در پاسخ به دستور مراجع قضایی ذی‌صلاح در اختیار نهادهای ذی‌ربط قرار دهد.',
        type: 'bullet',
        sub: null
      },{
        text: 'چنانچه وب‌وین با شرکتی دیگر ادغام شود یا به ساماندهی مجدد یا به فروش دارایی‌هایش اقدام کند، همچنان تمام اطلاعات شخصی محرمانه باقی خواهند ماند و هرگونه تصمیم به انتقال اطلاعات کاربران یا تغییر سیاست حریم شخصی به اطلاع کاربران خواهد رسید.',
        type: 'bullet',
        sub: null
      },{
        text: 'وب‌وین ممکن است اطلاعات جمع آوری شده را با اشخاص ثالثی که به منظور ارائه خدمات به شما، با ما همکاری و فعالیت می کنند نیز قرار دهد. بدیهی است که حدود اطلاعات ارائه شده به این اشخاص، همواره و صرفاً محدود به همان مواردی خواهد بود که در راستای  استفاده از خدمات  وب‌وین با ما همکاری و فعالیت می کنند و این اشخاص صرفاً در چارچوب این سند می توانند اقدام به پردازش یا استفاده از اطلاعات شما نمایند.',
        type: 'bullet',
        sub: null
      },
    ]
  },{
    title: 'امنیت اطلاعات',
    body: [
      {
        text: 'وب‌وین در کشور جمهوری اسلامی ایران مستقر بوده و کلیه اطلاعات جمع‌آوری شده، در دیتاسنترهای مورد تایید سازمان فن‌آوری اطلاعات و ارتباطات ایران و بر روی سرورهای داخل کشور نگهداری و ذخیره‌سازی می‌گردند که این امر موجب بالا رفتن امنیت اطلاعات خصوصی شما خواهد شد.',
        type: 'bullet',
        sub: null
      },{
        text: 'برای هر بار ورود به حساب کاربری در وب‌وین از رمز عبور یک‌بار مصرف (OTP) استفاده می‌شود که تنها با دسترسی به شماره تلفن همراهی که از طریق آن در وب‌وین ، حساب کاربری خود را ایجاد کرده‌اید امکان‌پذیر است.',
        type: 'bullet',
        sub: null
      },{
        text: 'در صورت وقوع سرقت گوشی همراه و همچنین پیش از واگذاری شماره تلفنی که با آن حساب کاربری ایجاد کرده‌اید، موضوع را به وب‌وین اطلاع دهید تا حساب کاربری شما تعلیق شده یا اطلاعات موجود در آن تغییر کند. در غیر این صورت و در موارد دسترسی اشخاص ثالث به اطلاعات حساب کاربری شما، وب‌وین هیچ‌گونه مسئولیتی در این مورد نخواهد داشت.',
        type: 'bullet',
        sub: null
      },
    ]
  },{
    title: 'نگهداری اطلاعات',
    body: [
      {
        text: 'وب‌وین تا زمانی که به منظور ارائه خدمات به شما نیاز به اطلاعات مذکور در این سند داشته باشد، اقدام به نگهداری از این اطلاعات خواهد نمود. معیار تعیین این بازه زمانی عبارت اند از:',
        type: 'text',
        sub: null
      },{
        text: 'مدت زمانی که وب‌وین با شما دارای رابطه قراردادی به منظور ارائه خدمات است؛',
        type: 'bullet',
        sub: null
      },{
        text: 'تعهدات قانونی وب‌وین به حفظ و نگهداری اطلاعات کاربران خود؛',
        type: 'bullet',
        sub: null
      },{
        text: 'نگهداری اطلاعات در مواردی که این امر به منظور حفظ حقوق و منافع قانونی وب‌وین، ضروری و یا به مصلحت باشد.',
        type: 'bullet',
        sub: null
      },
    ]
  },{
    title: 'شفافیت، حق انتخاب و سؤالات حریم شخصی',
    body: [
      {
        text: 'کاربران مختلف نگرانی‌های مختلفی در خصوص حریم شخصی خود دارند. هدف ما شفافیت کامل در خصوص اطلاعاتی است که جمع آوری می‌کنیم، تا بتوانید در خصوص استفاده‌ای که از آنها می شود حق انتخاب داشته باشید. تصمیم گیری در خصوص نحوه دسترسی وب‌وین به اطلاعات شخصی و غیرشخصی شما بر عهده شماست. لطفا هر سؤال، ابهام یا دغدغه‌ای دربارۀ حریم شخصی خود دارید به سادگی از طریق ایمیل با وب‌وین مطرح کنید. تمامی تماس‌ها و ایمیل‌ها پاسخ داده می‌شوند و تا حد امکان به پیشنهادهای خوب کاربران ترتیب اثر داده خواهد شد.',
        type: 'text',
        sub: null
      },
    ]
  },{
    title: 'درخواست های شما',
    body: [
      {
        text: 'تحت شرایطی، شما می توانید متقاضی هر یک از موارد ذیل در رابطه با اطلاعات شخصی خود باشید:',
        type: 'text',
        sub: null
      },{
        text: 'درخواست دسترسی به اطلاعات شخصی خود که در اختیار وب‌وین قرار دارد،',
        type: 'bullet',
        sub: null
      },{
        text: 'درخواست تکمیل اطلاعات ناقص یا اصلاح اطلاعات نادرستی که در اختیار وب‌وین قرار دارد،',
        type: 'bullet',
        sub: null
      },{
        text: 'درخواست حذف یا محو کردن اطلاعات شخصی؛ در این خصوص وب‌وین درخواست شما را بررسی و تنها در چارچوبی که قانون اجازه می‌دهد اطلاعات را حذف یا محو می‌نماید و به نحو مقتضی به شما اطلاع‌رسانی خواهد کرد،',
        type: 'bullet',
        sub: null
      },
    ]
  },{
    title: 'شرایط درخواست',
    body: [
      {
        text: 'شما می توانید درخواست های خود را به نشانی الکترونیکی info@fdpco.ir ارسال نمایید.',
        type: 'text',
        sub: null
      },{
        text: 'در هر یک از موارد فوق، وب‌وین ممکن است اطلاعاتی را به منظور تأیید هویت و حصول اطمینان از حق دسترسی شما به اطلاعات شخصی، درخواست کند. این اقدامات و تدابیر با هدف محافظت از اطلاعات و جلوگیری از دسترسی‌های غیرمجاز به اطلاعات شخصی شما انجام می‌شوند.',
        type: 'text',
        sub: null
      },{
        text: 'وب‌وین هر درخواست را ظرف حداکثر یک ماه پاسخ خواهد داد مگر آنکه پیچیدگی یا تعدد موضوعات بررسی طولانی‌تری را اقتضا کند؛ در این صورت وب‌وین ، اطلاع‌رسانی های لازم را انجام خواهد داد.',
        type: 'text',
        sub: null
      },
    ]
  },
]

function PrivacyPolicy(props) {
  
  return (
    <div className="privacy-policy">
      <Link to="/" className="link-logo">
        <img src={AppLogo} alt="session-logo" />
        <img src={AppLogoText} alt="session-logo" />
      </Link>
      <div className="content">
        {
          rules.map(item => {
            return <div className="each-rule">
              <div className="content-title">
                <Icons.Diamond size={20}/>
                <h3>
                  {item.title}
                </h3>
              </div>
              <div className="content-body border-right">
                {
                  item.body.map(b => {
                    return <>
                      {
                        b.type === 'text' &&
                        <p>{b.text}</p>
                      }
                      {
                        b.type === 'bullet' &&
                        <div>
                          <p><Icons.CircleFill size={8} className="mb-1 mx-2"/> {b.text}</p>
                          <div className="sub-bullet border-right">
                            {
                              b.sub && b.sub.map(s => {
                                return <>
                                {
                                  s.type === 'text' &&
                                  <p>{s.text}</p>
                                }
                                {
                                  s.type === 'bulletInner' &&
                                  <p><Icons.Diamond size={8} className="mb-1 mx-2"/> {s.text}</p>
                                }
                                </>
                              })
                            }
                          </div>
                        </div>
                      }
                    </>
                  })
                }
              </div>
            </div>
          })
        }
      </div>
      <div className="bottom-info-text">
        <h6>تمامی حقوق وب اپلیکیشن</h6>
        <h6 className="text-blue">وب‌وین</h6>
        <h6>متعلق به شرکت</h6>
        <h6><a href="https://fdpco.ir/" target="_blank">فناوری داده پویشگر</a></h6>
        <h6>می‌باشد</h6>
      </div>
    </div>
  );
}

export default PrivacyPolicy;